/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum CreationSource {
  CSV="CSV",
FORM="FORM",
CUSTOMERS="CUSTOMERS",
ORDERS="ORDERS",
API="API",
SHOPIFY="SHOPIFY",
ZAPIER="ZAPIER"
}

/**
* CreationSource
*/
export const CreationSourceEnumType = types.enumeration("CreationSource", [
        "CSV",
  "FORM",
  "CUSTOMERS",
  "ORDERS",
  "API",
  "SHOPIFY",
  "ZAPIER",
      ])
